import React, { useEffect, useState } from 'react'
import { faFlask, faSeedling, faSprayCan } from '@fortawesome/free-solid-svg-icons'

import { v4 as uid } from 'uuid'
import { orderBy } from 'lodash'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
import { InsumosItens, putInsumos } from '../../../../../../services/recomendacao/insumos'
import {
  destroyAlert,
  errorAlert,
  infoAlert,
  loadingAlert,
  successAlert,
} from '../../../../../../utils/alert'
import { tryError } from '../../../../../../services/Afins'
import { HeaderDrawer } from '../../../../../../Components/CustomUi/headerGaveta'
import { BodyDrawer } from './styles'
import { Render } from '../../../../../../Components/CustomUi/render'
import Carregando from '../../../../../../Components/CustomUi/loading'
import Tabs from '../../../../../../Components/Tabs'
import { FormDadosInsumo } from './components/dadosInsumos'
import { FormComposicao } from './components/composicao'
import { FormAplicacao } from './components/aplicacao'
import { AxiosResponse } from 'axios'
import {
  getMoniEspecie,
  MoniEspecieItens,
  TypeMoniEspecie,
} from '../../../../../../services/monitoramento/especie'
export interface TypeInsetAtivos {
  uid: string
  cod: number
  cod_ativo: number
  editable?: boolean
  nomeAtivo: string
  concentracao: number
}

interface PropsFormInsumoNovo {
  update: number
  criadoPorAtualizadoPor: string
  loadingForm: boolean
  permissions: ItensPerUserLogged
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  categoria_insumo: string
  setCategoria_insumo: React.Dispatch<React.SetStateAction<string>>
  categoria_insumoId: number
  setCategoria_insumoId: React.Dispatch<React.SetStateAction<number>>
  classeAgro: string
  setClasseAgro: React.Dispatch<React.SetStateAction<string>>
  classeAgroId: number
  setClasseAgroId: React.Dispatch<React.SetStateAction<number>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  fabricanteId: number
  setFabricanteId: React.Dispatch<React.SetStateAction<number>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  formulacaoId: number
  setFormulacaoId: React.Dispatch<React.SetStateAction<number>>
  unidadeDose: string
  setUnidadeDose: React.Dispatch<React.SetStateAction<string>>
  unidadeDoseId: number
  setUnidadeDoseId: React.Dispatch<React.SetStateAction<number>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>

  //INSUMOS
  dataCatProduto: any[]
  dataCatCategoria: any[]
  dataFabricantes: any[]
  dataFormulacao: any[]
  dataUnidadeMedida: any[]
  handleChangeClasse: Function

  //COMPOSICAO
  ativo: string
  setAtivo: React.Dispatch<React.SetStateAction<string>>
  ativosId: number
  setAtivoId: React.Dispatch<React.SetStateAction<number>>
  concentracao: string
  setConcentracao: React.Dispatch<React.SetStateAction<string>>
  ativos: TypeInsetAtivos[]
  setAtivos: React.Dispatch<React.SetStateAction<TypeInsetAtivos[]>>
  dataAtivos: any[]

  //APLICAÇÃO
  cultura: string
  setCultura: React.Dispatch<React.SetStateAction<string>>
  culturaId: number
  setCulturaId: React.Dispatch<React.SetStateAction<number>>
  faseDeCultura: string
  setFaseDeCultura: React.Dispatch<React.SetStateAction<string>>
  faseDeCulturaId: number
  setFaseDeCulturaId: React.Dispatch<React.SetStateAction<number>>
  aplicacoes: InsumosItens['aplicacoes']
  setAplicacoes: React.Dispatch<React.SetStateAction<InsumosItens['aplicacoes']>>
  especieNome: string
  setEspecieNome: React.Dispatch<React.SetStateAction<string>>
  especieId: number
  setEspecieId: React.Dispatch<React.SetStateAction<number>>
  variacaoEspecie: string
  setVariacaoEspecie: React.Dispatch<React.SetStateAction<string>>
  variacaoEspecieId: number
  setVariacaoEspecieId: React.Dispatch<React.SetStateAction<number>>
  doseBula: string
  setDoseBula: React.Dispatch<React.SetStateAction<string>>
  doseUsual: string
  setDoseUsual: React.Dispatch<React.SetStateAction<string>>
  alvoSelect: number
  setAlvoSelect: React.Dispatch<React.SetStateAction<number>>
  doseBulaUpdate: string
  setDoseBulaUpdate: React.Dispatch<React.SetStateAction<string>>
  doseUsualUpdate: string
  setDoseUsualUpdate: React.Dispatch<React.SetStateAction<string>>
  codClone: number
  adicionarAtivos: Function
  updateAlvo: Function
  handleRemoveAtivo: Function
  removeAlvo: Function
}

const FormInsumoNovo: React.FC<PropsFormInsumoNovo> = ({
  update,
  criadoPorAtualizadoPor,
  loadingForm,
  permissions,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  nome,
  setNome,
  categoria_insumo,
  setCategoria_insumo,
  categoria_insumoId,
  setCategoria_insumoId,
  classeAgro,
  setClasseAgro,
  classeAgroId,
  setClasseAgroId,
  fabricante,
  setFabricante,
  fabricanteId,
  setFabricanteId,
  formulacao,
  setFormulacao,
  formulacaoId,
  setFormulacaoId,
  unidadeDose,
  setUnidadeDose,
  unidadeDoseId,
  setUnidadeDoseId,
  observacao,
  setObservacao,
  ativo,
  setAtivo,
  ativosId,
  setAtivoId,
  concentracao,
  setConcentracao,
  cultura,
  setCultura,
  culturaId,
  setCulturaId,
  faseDeCultura,
  setFaseDeCultura,
  faseDeCulturaId,
  setFaseDeCulturaId,
  ativos,
  setAtivos,
  aplicacoes,
  setAplicacoes,
  especieNome,
  setEspecieNome,
  especieId,
  setEspecieId,
  variacaoEspecie,
  setVariacaoEspecie,
  variacaoEspecieId,
  setVariacaoEspecieId,
  doseBula,
  setDoseBula,
  doseUsual,
  setDoseUsual,
  alvoSelect,
  setAlvoSelect,
  doseBulaUpdate,
  setDoseBulaUpdate,
  doseUsualUpdate,
  setDoseUsualUpdate,
  adicionarAtivos,
  dataCatProduto,
  dataCatCategoria,
  dataFabricantes,
  dataFormulacao,
  dataUnidadeMedida,
  dataAtivos,
  handleChangeClasse,
  updateAlvo,
  handleRemoveAtivo,
  removeAlvo,
}) => {
  const [updateConcentracao, setUpdateConcentracao] = useState(null)

  //APLICAÇÃO
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [loadingAlvos, setLoadingAlvos] = useState(false)
  const [dataEspecie, setDataEspecie] = useState<MoniEspecieItens[]>([] as MoniEspecieItens[])

  //COMPOSIÇÃO
  const [confirmar_exclusao_composicao, setConfirmar_exclusao_composicao] = useState<boolean>(false)
  const [id_item_atual_composicao, setId_item_atual_composicao] = useState<number>(null)
  const [nome_item_atual_composicao, setNome_item_atual_composicao] = useState<string>('')
  const [fake_loading_composicao, setFake_loading_composicao] = useState<boolean>(false)

  const listEspecie = async () => {
    const resp: AxiosResponse<TypeMoniEspecie> = await getMoniEspecie({
      embed: 'variacao',
      pagination: -1,
    })

    const dados = orderBy(resp.data.itens, ['cod_categoria'])

    setDataEspecie(dados)
  }

  const editarAtivo = (uid) => {
    const dados = [...ativos]
    dados.forEach((data) => {
      if (data.uid === uid) {
        data.editable = true
      } else {
        data.editable = false
      }
    })
    setAtivos(dados)
  }

  const salvarAtivo = (cod) => {
    const dados = [...ativos]
    dados.forEach((data) => {
      if (data.cod === cod) {
        data.concentracao = updateConcentracao
      }
      data.editable = false
    })

    setAtivos(dados)
  }

  const handleChangeMask = (data) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')
    return area
  }

  const mudarConcentracao = (concen, uid) => {
    let concentracao = handleChangeMask(concen)
    const dados = [...ativos]
    let temp = []
    dados.forEach((data) => {
      if (data.uid === uid) {
        data.concentracao = concentracao
        setUpdateConcentracao(concentracao)
      }
      temp = [...temp, data]

      return temp
    })

    setAtivos(temp)
  }

  const handleInsertCultura = () => {
    const formAplica = {
      cultura: culturaId,
      faseCultura: faseDeCulturaId,
    }

    if (Number.isNaN(formAplica.cultura) || formAplica.cultura === undefined) {
      errorAlert('Campo cultura inválido!')
      return
    }
    if (Number.isNaN(formAplica.faseCultura) || formAplica.faseCultura === undefined) {
      errorAlert('Campo fase da cultura inválido!')
      return
    }

    const verifica = aplicacoes.find(
      (data) =>
        data.cod_cultura === formAplica.cultura && data.cod_fase_cultura === formAplica.faseCultura
    )
    if (!verifica) {
      setAplicacoes([
        ...aplicacoes,
        {
          cod: uid(),
          cod_cultura: culturaId,
          cod_fase_cultura: faseDeCulturaId,
          cultura_nome: cultura,
          fase_cultura_nome: faseDeCultura,
          alvos: [],
        },
      ])
      setCultura('')
      setFaseDeCultura('')
      setCulturaId(null)
      setFaseDeCulturaId(null)
    } else {
      errorAlert('Cultura e fase da cultura já inserida!')
    }
  }

  const adicionarAlvo = (cod, index) => {
    setLoadingAlvos(true)
    if (doseBula === undefined || doseBula === null || doseBula === '') {
      infoAlert('Favor informar uma dose de bula!')
      setLoadingAlvos(false)
      return
    }
    if (doseUsual === undefined || doseUsual === null || doseUsual === '') {
      infoAlert('Favor informar uma dose usual!')
      setLoadingAlvos(false)
      return
    }

    let dados = []
    if (update <= 0) {
      dados = aplicacoes.map((item) => {
        if (item?.cod === cod) {
          const jaCadastrado = item?.alvos.some(
            (item) =>
              item.cod_especie === especieId && item.cod_variacao_especie === variacaoEspecieId
          )

          if (jaCadastrado) {
            errorAlert('Alvo ja cadastrado!')
            setLoadingAlvos(false)
            return item
          }

          return {
            ...item,
            alvos: [
              ...item?.alvos,
              {
                cod: uid(),
                dose_bula: Number(doseBula?.replace(',', '.')),
                dose_usual: Number(doseUsual?.replace(',', '.')),
                cod_cultura: culturaId,
                cod_especie: especieId,
                cod_variacao_especie: variacaoEspecieId,
              },
            ],
          }
        }
        return item
      })
    } else {
      dados = aplicacoes.map((item) => {
        if (item?.cod === cod) {
          const jaCadastrado = item?.alvos.some(
            (item) =>
              item.cod_especie === especieId && item.cod_variacao_especie === variacaoEspecieId
          )

          if (jaCadastrado) {
            errorAlert('Alvo ja cadastrado!')
            setLoadingAlvos(false)
            return item
          }
          return {
            ...item,
            alvos: [
              ...item?.alvos,
              {
                cod: uid(),
                dose_bula: Number(doseBula?.replace(',', '.')),
                dose_usual: Number(doseUsual?.replace(',', '.')),
                cod_cultura: culturaId,
                cod_especie: especieId,
                cod_variacao_especie: variacaoEspecieId,
              },
            ],
          }
        }
        return item
      })
    }

    setDoseBula('')
    setDoseUsual('')
    setEspecieNome('')
    setEspecieId(null)
    setVariacaoEspecie('')
    setVariacaoEspecieId(null)
    setAplicacoes(orderBy(dados, 'nome'))
    setTimeout(() => {
      setLoadingAlvos(false)
    }, 500)
  }

  const copiarAlvo = (data) => {
    setDoseBula(String(data?.dose_bula))
    setDoseUsual(String(data?.dose_usual))
  }

  const handleClickCloneAplica = (cod) => {
    try {
      const codCultura = culturaId
      const codFaseCultura = faseDeCulturaId
      if (codCultura === null) {
        infoAlert('Selecione uma cultura e a fase da cultura para clonar a aplicação!')
      } else if (codFaseCultura === null) {
        infoAlert('Selecione uma cultura e a fase da cultura para clonar a aplicação!')
      } else {
        const f = aplicacoes.filter(
          (item) => item.cod_cultura === codCultura && item.cod_fase_cultura === codFaseCultura
        )

        if (f.length <= 0) {
          const dados = aplicacoes.find((item) => item.cod === cod)

          const aplicacao = {
            cod: uid(),
            cod_cultura: codCultura,
            cultura_nome: cultura,
            cod_fase_cultura: codFaseCultura,
            alvos: dados.alvos.map((item) => {
              item.cod = uid()
              return item
            }),
          }

          setAplicacoes([...aplicacoes, aplicacao])
          setCultura('')
          setCulturaId(null)
          setFaseDeCultura('')
          setFaseDeCulturaId(null)
        } else {
          errorAlert('Cultura ja cadastrada!')
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleRemoveCultura = async (cod) => {
    try {
      if (typeof cod === 'string') {
        setAplicacoes(aplicacoes.filter((item) => item.cod !== cod))
      } else {
        const remover = () => {
          const dados = [...aplicacoes]

          const remove = dados.filter((data) => data.cod !== cod)

          setAplicacoes(remove)
          successAlert('Aplicação removida com sucesso!')
        }

        if (update === 0) {
          remover()
        } else {
          loadingAlert({ msg: 'Removendo...', id: 'remove_ativo' })
          const resp = await putInsumos(
            update,
            { aplicacoes_remover: [cod] },
            { embed: 'aplicacoes,alvos,composicao' }
          )

          if (resp.status === 200) {
            remover()
            destroyAlert('remove_ativo')
          } else {
            destroyAlert('remove_ativo')
          }
        }
      }
    } catch (error) {
      tryError(error)
    }
  }

  useEffect(() => {
    listEspecie()
  }, [])

  return (
    <>
      <HeaderDrawer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {update > 0 ? 'Atualizar catálogo insumo' : 'Cadastrar catálogo insumo'}

          <small style={{ opacity: '0.5', fontSize: '9px' }}>{criadoPorAtualizadoPor}</small>
        </div>
      </HeaderDrawer>
      <BodyDrawer>
        <Render condition={loadingForm}>
          <Carregando
            animation
            justifyContent='center'
            height={'550px'}
            legenda='Carregando informações...'
          />
        </Render>
        <Render condition={loadingForm === false}>
          <Tabs
            tabs={[
              { descricao: 'Dados do insumo', icone: faSeedling },
              { descricao: 'Composição', icone: faFlask },
              { descricao: 'Aplicação', icone: faSprayCan },
            ]}
            selecionado={tab_selecionar_atual}
            trackWidth={253}
            onChange={setTab_selecionar_atual}
          />

          <Render condition={tab_selecionar_atual === 'Dados do insumo'}>
            <FormDadosInsumo
              nome={nome}
              setNome={setNome}
              categoria_insumo={categoria_insumo}
              setCategoria_insumo={setCategoria_insumo}
              setCategoria_insumoId={setCategoria_insumoId}
              classeAgro={classeAgro}
              setClasseAgro={setClasseAgro}
              setClasseAgroId={setClasseAgroId}
              fabricante={fabricante}
              setFabricante={setFabricante}
              setFabricanteId={setFabricanteId}
              formulacao={formulacao}
              setFormulacao={setFormulacao}
              setFormulacaoId={setFormulacaoId}
              unidadeDose={unidadeDose}
              setUnidadeDose={setUnidadeDose}
              setUnidadeDoseId={setUnidadeDoseId}
              observacao={observacao}
              setObservacao={setObservacao}
              dataCatProduto={dataCatProduto}
              dataCatCategoria={dataCatCategoria}
              dataFabricantes={dataFabricantes}
              dataFormulacao={dataFormulacao}
              dataUnidadeMedida={dataUnidadeMedida}
              handleChangeClasse={handleChangeClasse}
              permissions={permissions}
            />
          </Render>
          <Render condition={tab_selecionar_atual === 'Composição'}>
            <FormComposicao
              dataAtivos={dataAtivos}
              ativo={ativo}
              setAtivo={setAtivo}
              ativosId={ativosId}
              setAtivoId={setAtivoId}
              concentracao={concentracao}
              setConcentracao={setConcentracao}
              adicionarAtivos={adicionarAtivos}
              ativos={ativos}
              salvarAtivo={salvarAtivo}
              editarAtivo={editarAtivo}
              mudarConcentracao={mudarConcentracao}
              confirmar_exclusao={confirmar_exclusao_composicao}
              setConfirmar_exclusao={setConfirmar_exclusao_composicao}
              id_item_atual={id_item_atual_composicao}
              setId_item_atual={setId_item_atual_composicao}
              nome_item_atual={nome_item_atual_composicao}
              setNome_item_atual={setNome_item_atual_composicao}
              fake_loading={fake_loading_composicao}
              setFake_loading={setFake_loading_composicao}
              handleRemoveAtivo={handleRemoveAtivo}
              permissions={permissions}
            />
          </Render>
          <Render condition={tab_selecionar_atual === 'Aplicação'}>
            <FormAplicacao
              cultura={cultura}
              setCultura={setCultura}
              culturaId={culturaId}
              setCulturaId={setCulturaId}
              faseDeCultura={faseDeCultura}
              setFaseDeCultura={setFaseDeCultura}
              faseDeCulturaId={faseDeCulturaId}
              setFaseDeCulturaId={setFaseDeCulturaId}
              aplicacoes={aplicacoes}
              handleInsertCultura={handleInsertCultura}
              especie={especieNome}
              setEspecie={setEspecieNome}
              especieId={especieId}
              setEspecieId={setEspecieId}
              variacaoEspecie={variacaoEspecie}
              setVariacaoEspecie={setVariacaoEspecie}
              variacaoEspecieId={variacaoEspecieId}
              setVariacaoEspecieId={setVariacaoEspecieId}
              doseBula={doseBula}
              setDoseBula={setDoseBula}
              doseUsual={doseUsual}
              setDoseUsual={setDoseUsual}
              adicionarAlvo={adicionarAlvo}
              alvoSelect={alvoSelect}
              setAlvoSelect={setAlvoSelect}
              updateAlvo={updateAlvo}
              copiarAlvo={copiarAlvo}
              removerAlvo={removeAlvo}
              doseBulaUpdate={doseBulaUpdate}
              setDoseBulaUpdate={setDoseBulaUpdate}
              doseUsualUpdate={doseUsualUpdate}
              setDoseUsualUpdate={setDoseUsualUpdate}
              confirmar_exclusao={confirmar_exclusao}
              setConfirmar_exclusao={setConfirmar_exclusao}
              id_item_atual={id_item_atual}
              setId_item_atual={setId_item_atual}
              nome_item_atual={nome_item_atual}
              setNome_item_atual={setNome_item_atual}
              fake_loading={fake_loading}
              setFake_loading={setFake_loading}
              unidadeMedidaId={unidadeDoseId}
              dataUnidadeMedida={dataUnidadeMedida}
              loadingAlvos={loadingAlvos}
              handleClickCloneAplica={handleClickCloneAplica}
              handleRemoveCultura={handleRemoveCultura}
              permissions={permissions}
              dataEspecie={dataEspecie}
            />
          </Render>
        </Render>
      </BodyDrawer>
    </>
  )
}

export default FormInsumoNovo
